<template>
  <a-modal v-model="visible" 
    :maskClosable="!loading"
    title="" width="600px" @cancel="$emit('close')"
  >
    <template slot="footer">
      <a-button
        @click="validateSubmit"
        key="submit"
        :loading="loading"
        style="background-color:#20409a; color: #fff"
      >
        {{ loading ? 'Submitting...' : 'Submit' }}
      </a-button>
    </template>
    <h4 class="font-weight-bolder text-left kova-text">
      Submit Sprint Project
    </h4>
    <p class="text-left">
        Ensure your code is pushed to <strong> Gitlab </strong> for submission
      </p>
    <div>
      <p class="mt-4">Repo link on Gitlab</p>
      <a-input size="large" v-model="submission_link" placeholder="https://gitlab.com/username/repo" />
      <p class="error my-0" v-if="error">{{ error }}</p>
    </div>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    test: Object,
  },
  data: () => ({
    loading: false,
    submission_link: '',
    error: '',
  }),
  methods: {
    validateSubmit() {
      const { submission_link } = this;
      const message = !submission_link ? 'Please enter the Gitlab link to your sprint project'
        : !submission_link.includes('.com/')
          ? 'This is not a valid link!'
          : !submission_link.includes('gitlab.com/')
            ? 'Please only Gitlab is used for submission'
            : '';

      if(message.length) return this.error = message;
      this.error = '';
      this.submitProject({ submission_link });
    },
    async submitProject(data) {
      this.loading = true;
      const token = localStorage.getItem('token');
      try {
        const res = await this.$api({
          url: `/tests/${this.test.ID}/submit`,
          method: 'put',
          headers: {
            Authorization: `Bearer ${token}`,
          },
          data,
        });
        this.loading = false;
        this.$emit('done', res.data);
      } catch (err) {
        this.loading = false;
        if(err.response.data.toLowerCase().includes("denied")) {
          this.showError('Oops!', 'The time limit for this test has exceeded!')
          this.$emit('done');
          return;
        }
        this.catchErrors(err);
        // console.log(err)
      }
    },
  }
};
</script>

<style scoped>
  .error {
    color: #fc0404;
    text-align: left;
  }
</style>